import request from "@/utils/request"
//获取预充值pagelist
export function GetRechargePageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetRechargePageList",
    method: "post",
    data
  })
}
//获取预充值统计信息
export function GetRechargeStatisticInfo(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetRechargeStatisticInfo",
    method: "post",
    data
  })
}

///获取初装记录
export function GetFeeTableInitPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetFeeTableInitPageList",
    method: "post",
    data
  })
}

///获取初装记录统计信息
export function getFeeTableInitStatisticInfoApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetFeeTableInitStatisticInfo",
    method: "post",
    data
  })
}

//微信退款功能
export function WxReturnMoney(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/WxReturnMoney",
    method: "get",
    params
  })
}
//获取余额异常pagelist
export function GetBalanceErrorPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetBalanceErrorPageList",
    method: "post",
    data
  })
}

//设备与费控表解绑
export function UnBindPoleAndFeetableForBack(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/UnBindPoleAndFeetableForBack",
    method: "get",
    params
  })
}
//人工绑定（临时使用）
export function BindFeetableByHand(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/BindFeetableByHand",
    method: "post",
    data
  })
}
